import { render, staticRenderFns } from "./m-icon-bar.vue?vue&type=template&id=325fdaf2&scoped=true&"
import script from "./m-icon-bar.vue?vue&type=script&lang=js&"
export * from "./m-icon-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325fdaf2",
  null
  
)

export default component.exports